import React from 'react'
import { Modal, ModalBody } from 'reactstrap'
import './MyModal.css'

const MyModal = ({
  modal,
  toggle,
  title,
  body,
  icon = null,
  closeButton = false,
  setHeight = null,
}) => {
  return (
    <Modal
      isOpen={modal}
      toggle={toggle}
      scrollable={true}
      centered={true}
      contentClassName={'myModal'}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        borderRadius: '500px'
      }}
    >
      {closeButton && (
        <button
          onClick={toggle}
          style={{
            position: 'absolute',
            zIndex: 999,
            top: '15px',
            right: '15px',
            backgroundColor: '#DBEBE4',
            color: '#205c42',
            fontSize: '17px',
            padding: '.1rem .6rem',
            border: 'none',
            borderRadius: '100%',
          }}
        >
          X
        </button>
      )}

      <ModalBody
        style={{
          position:'relative',
          fontSize: '0.9rem',
          height: setHeight ? setHeight : '100%',
          // maxHeight: '250px',
        }}
      >
        {body}
      </ModalBody>
    </Modal>
  )
}

export default MyModal
